import React, { useState, useEffect } from 'react';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import Router from '../../Router';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			flexWrap: 'wrap',
			width: 400,
			margin: `${theme.spacing(0)} auto`
		},
		loginBtn: {
			flexGrow: 1,
		},
		header: {
			textAlign: 'center',
			background: '#91b341',
			//color: '#fff'
		},
		card: {
			marginTop: theme.spacing(10)
		}

	}),
);

const CssTextField = withStyles({
	root: {
		'& label.Mui-focused': {
			color: '#91b341',
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: '#91b341',
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: '#91b341',
			},
		},
	},
})(TextField);

const Login = () => {
	const classes = useStyles();
	const [authToken, setAuthToken] = React.useState(localStorage.getItem('token'));
	const [password, setPassword] = useState('');
	const [showPass, setShowPass] = React.useState(false);
	const [isButtonDisabled, setIsButtonDisabled] = useState(true);
	const [helperText, setHelperText] = useState('');
	const [error, setError] = useState(false);

	useEffect(() => {
		if (password.trim()) {
			setIsButtonDisabled(false);
		} else {
			setIsButtonDisabled(true);
		}
	}, [password]);

	const handleLogin = () => {
		if (password === 'password') {
			setError(false);
			localStorage.setItem('token', 'true');
			setAuthToken(localStorage.getItem('token'));
		} else {
			setError(true);
			setHelperText('Incorrect password')
		}
	};

	const handleKeyPress = (e: any) => {
		if (e.keyCode === 13 || e.which === 13) {
			isButtonDisabled || handleLogin();
		}
	};

	const handleClickShowPassword = () => {
		setShowPass(!showPass);
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};
	return (
		authToken ?
			(<Router />) :
			(
				<React.Fragment>
					<form className={classes.container} noValidate autoComplete="off">
						<Card className={classes.card}>
							<CardHeader className={classes.header} title="Login" />
							<CardContent>
								<div>
									<CssTextField
										error={error}
										fullWidth
										id="password"
										type={showPass ? 'text' : 'password'}
										label="Password"
										margin="normal"
										helperText={helperText}
										onChange={(e) => setPassword(e.target.value)}
										onKeyPress={(e) => handleKeyPress(e)}
										InputProps={
											{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={handleClickShowPassword}
															onMouseDown={handleMouseDownPassword}
															style={{
																padding: '0',
															}}
														>
															{showPass ? <Visibility /> : <VisibilityOff />}
														</IconButton>
													</InputAdornment>
												)
											}
										}
									/>
								</div>
							</CardContent>
							<CardActions>
								<Button
									variant="outlined"
									size="large"
									className={classes.loginBtn}
									onClick={() => handleLogin()}
									disabled={isButtonDisabled}>
									Login
								</Button>
							</CardActions>
						</Card>
					</form>
				</React.Fragment>
			)
	);
}

export default Login;
